<template>
    <div class="d-flex flex-column">
        <h6 v-if="fromUser" class="text-center mb-4">
            <router-link :to="{ path: '/portal/users' }">
                Users
            </router-link>
            /
            <router-link :to="{ path: `/portal/users/${fromUser}` }">
                {{ fromUser }}
            </router-link>
            / Orders / {{ async.loading ? '' : results.id || 'Not Found' }}
        </h6>
        <h6 v-else class="text-center mb-4">
            <router-link :to="{ path: '/portal/orders' }">
                Orders
            </router-link>
            / {{ async.loading ? '' : results.id || 'Not Found' }}
        </h6>
        <AsyncWrapper
            :data="results"
            :loading="async.loading"
            :error="async.error"
            :wrapperClass="'d-flex flex-column justify-content-center align-items-center'"
        >
            <template slot="dataComponent">
                <order-view :order="results"></order-view>
            </template>
            <template slot="loadingComponent">
                <i class="fa fa-circle-o-notch fa-2x fa-spin"></i>
            </template>
            <template slot="errorComponent">
                <p>{{ async.error }}</p>
            </template>
            <template slot="emptyComponent">
                <p>No order with that id was found</p>
            </template>
        </AsyncWrapper>
    </div>
</template>
<script>
import OrderView from './OrderView'
export default {
    components: {
        OrderView
    },
    data() {
        return {
            fromUser: false
        }
    },
    computed: {
        results() {
            return this.$store.getters['orders/GET_ORDER']
        },
        async() {
            return this.$store.getters['orders/GET_ASYNC']
        }
    },
    created() {
        this.$store.dispatch('orders/FETCH_ORDER_BY_ID', {
            id: this.$route.params.id
        })
    },
    beforeRouteEnter(to, from, next) {
        if (from.name === 'user') {
            next((vm) => {
                vm.fromUser = from.params.id
            })
        }
        next()
    },
    beforeRouteLeave(to, from, next) {
        this.$store.dispatch('orders/REMOVE_ORDER_REFERENCE', {
            id: this.$route.params.id
        })
        next()
    }
}
</script>
